module.exports = __webpack_public_path__ + "static/media/train7.e47a8b60.png";